// extracted by mini-css-extract-plugin
export var chip = "_cq-0";
export var filterDropdown = "_cq-5";
export var filterItem = "_cq-6";
export var icon = "_cq-1";
export var removeButton = "_cq-3";
export var removeIcon = "_cq-4";
export var separator = "_cq-2";